import request from '@/utils/request'

export function listShopStaffMsg(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopMsg.listShopStaffMsg',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function listUnreadShopStaffMsgCount(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopMsg.listUnreadShopStaffMsgCount',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function readShopStaffMsg(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopMsg.readShopStaffMsg',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
